const decimalWithCommaExp = /^(-)?[0-9,]{0,13}\.?[0-9]{0,10}$/;

export const isNumberWithComma = val => decimalWithCommaExp.test(val);

export const replaceNumericCommaValue = (val) => {
  if (val) {
    // replace all the comma values in the number
    return val.toString().replace(/,/g, '');
  }
  return val;
}

export const uniqueArrayObject = (arr, objKey) => {
  const unique = arr
    .map(e => e[objKey])
  // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)
  // eliminate the dead keys & store unique objects
    .filter(e => arr[e]).map(e => arr[e]);

  return unique;
};

export const PageScrollVisible = (visible = false) => {
  const e = document.querySelector('#page');
  if (e) {
    e.style.overflow = visible ? 'initial' : 'hidden';
  }
};

export const SetKrContainerHeight = () => {
  const e = document.querySelector('.react-modal-side-panel .kr-modal-content');
  if (e) {
    const windowInnerHeight = window.innerHeight;
    e.style.minHeight = `${windowInnerHeight - 200}px`;
    e.style.maxHeight = `${windowInnerHeight - 200}px`;
  }
};

export const UcfirstChar = (string) => {
  if (typeof string !== 'string') return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const showTitleTooltip = (title, length = 90) => {
  let attr = {};
  if (typeof title !== 'undefined' && title !== null && title.length > length) {
    attr = { title };
  }
  return attr;
};

export const reorderItem = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const getColors = Index => ['#066DA9', '#76DDFB', '#FF9802', '#27B87B', '#F34488', '#019F82', '#192D4E', '#b946fc'];

export const ShowHidePageScroll = (visible = false) => {
  var e = document.querySelector('body');
  if(e){
      e.style.overflow = visible ? 'visible' : 'hidden';
  }
}

export const getUniqueWsResults =(respData,stateData)=>{
  let newTeams = {};
  Object.values(respData).map(item => {
    let findTeam = Object.values(stateData).find(i => i.id == item.id);
    if(findTeam){
      if(item.ws !== null){
        findTeam.ws = Object.assign(findTeam.ws,item.ws);
      }
    }else{
      let Iid = item.id;
      Object.assign(stateData,{[Iid]: item});
    }
    newTeams = stateData;
  })
  return newTeams;
}

export const truncateWithEllipsis = (text, max) => {
  const str = String(text);
  return str.length > max ? str.substring(0, max - 1) + '...' : str;
}

export const toTitleCase = (text) => {
  const words = text.split(' ');
  words.forEach((word, idx) => {
    words[idx] = word.charAt(0).toUpperCase() + word.slice(1);
  });
  return words.join(' ');
}

export default {
  isNumberWithComma,
  uniqueArrayObject,
  PageScrollVisible,
  SetKrContainerHeight,
  UcfirstChar,
  showTitleTooltip,
  reorderItem,
  ShowHidePageScroll,
  getUniqueWsResults,
  truncateWithEllipsis,
  toTitleCase,
};
